import React from "react";
import ReactDOM from "react-dom/client";
import MealBuilder from "./menu/mealBuilder/MealBuilder";
import MealSetup from "./menu/mealSetup/MealSetup";
// Meal builder comprises 2 parts:
//1. Initial setup ( subscription types, allergens, etc)
//2. Select meals 
const planSetup = document.getElementById("meal-plan-setup");
if (planSetup) {
    const planSetupRoot = ReactDOM.createRoot(planSetup);
    planSetupRoot.render(React.createElement(MealSetup, null));
}
const planBuilder = document.getElementById("meal-plan-builder");
if (planBuilder) {
    const planEditorRoot = ReactDOM.createRoot(planBuilder);
    //Various values taken from form
    const id = document.getElementById("meal-plan-id").value;
    const allergens = document.getElementById("meal-plan-allergens").value.replace(/ /g, "");
    const protein = document.getElementById("meal-plan-protein").value;
    const mode = document.getElementById("meal-plan-mode").value;
    const editId = document.getElementById("meal-plan-editId").value;
    const lineId = document.getElementById("meal-plan-lineId").value;
    const cartId = document.getElementById("meal-plan-cartId").value;
    const tempId = document.getElementById("meal-plan-tempId").value;
    planEditorRoot.render(React.createElement(MealBuilder, { id: id, allergens: allergens, protein: protein, mode: mode, editId: editId, lineId: lineId, cartId: cartId, tempId: tempId }));
}
